module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00003",
      "title": "[v]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_v"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "PREFACE"
    }
  }, [_vm._v("PREFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The year after Mr. Emerson’s death, Mr.\nCabot, in editing his works, gathered into\na volume the occasional writings which had\nnever been included in previous editions, although\nsix of them had been printed, either as\npamphlets or in periodicals, long before, by the\nauthor. These were the Sermon on The Lord’s\nSupper, the Historical Address at Concord in\n1835, that at the dedication of the Soldiers’\nMonument there in 1867, and that on Emancipation\nin the British West Indies, the Essay\non War, and the Editors’ Address in the\n"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Massachusetts Quarterly Review")]), _vm._v(". “American\nCivilization” had been a portion of the article\nof that name in the "), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Atlantic")]), _vm._v(" in 1862. “The\nFortune of the Republic” also had been printed\nas a pamphlet in 1874. Mr. Cabot said in his\nprefatory note, “In none was any change from\nthe original form made by me, except in the\n‘Fortune of the Republic,’ which was made up\nof several lectures, for the occasion upon which\nit was read.” This was after Mr. Emerson was"), _c('span', {
    attrs: {
      "id": "pgepubid00004",
      "title": "[vi]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_vi"
    }
  })]), _vm._v("\nno longer able to arrange his work and his\nfriends had come to his aid.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The speeches at the John Brown, the Walter\nScott, and the Free Religious Association\nmeetings had been printed, probably with Mr.\nEmerson’s consent. The other pieces included\nby Mr. Cabot, namely, the speeches on Theodore\nParker, the Emancipation Proclamation,\nAbraham Lincoln, at the Harvard Commemoration,\n“Woman,” the addresses to Kossuth,\nand at the Burns Festival, had not been published.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("All that were in Mr. Cabot’s collection will be\nfound here, although the order has been slightly\nchanged. To these I have added Mr. Emerson’s\nletter to President Van Buren in 1838, his\nspeech on the Fugitive Slave Law in Concord\nsoon after its enactment, that on Shakspeare\nto the Saturday Club, and his remarks at the\nHumboldt Centennial, and at the dinner to the\nChinese Embassy; also the addresses at the consecration\nof Sleepy Hollow Cemetery and at the\nopening of the Concord Free Public Library.\nThe oration before the New England Society\nof New York in 1870, printed by them in their\nrecent volume, is not included, as most of the"), _c('span', {
    attrs: {
      "id": "pgepubid00005",
      "title": "[vii]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_vii"
    }
  })]), _vm._v("\nmatter may be found in the Historical Discourse\nat Concord and in the essay “Boston,” in\n"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Natural History of Intellect")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("I have given to the chapters mottoes, the\nmost of them drawn from Mr. Emerson’s\nwritings.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("EDWARD W. EMERSON.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00006",
      "title": "[viii]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_viii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0